<ng-container *ngIf="dataAccessPolicy$ | async as dap">
  <ng-container *ngIf="!onlyStep">
    <p>{{ accessRequirement?.instructions }}</p>
    <ng-container *ngIf="dap | rdsIsDataUsageAgreement as dua">
      <div *ngIf="dua.dataUsageAgreementContents as contents">
        <div class="dua-contents-container-small">
          <div class="dua-contents" [innerHTML]="contents"></div>
        </div>
        <div>
          <span fxFlex></span>
          <mat-checkbox (change)="checkBoxValueChange($event)">
            <mat-label i18n>I agree to the data usage agreement</mat-label>
          </mat-checkbox>
          <span fxFlex></span>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="onlyStep">
    <ng-container *ngIf="dap | rdsIsDataUsageAgreement as dua">
      <div *ngIf="dua.dataUsageAgreementContents as contents">
        <div class="dua-contents-container">
          <div class="dua-contents" [innerHTML]="contents"></div>
        </div>
        <div>
          <span fxFlex></span>
          <mat-checkbox (change)="checkBoxValueChange($event)">
            <mat-label i18n>I agree to the data usage agreement</mat-label>
          </mat-checkbox>
          <span fxFlex></span>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
